const de = {
    "2 GB 以上":"2GB oder mehr",
    "512MB 以上":"512 MB oder mehr",
    "5GB 以上":"5 GB oder mehr",
    "Direct X 9.0 以上":"Direct X 9.0 oder neuer",
    "FB私訊":"FB Direktnachricht",
    "Gefrce 8600GR 以上":"Geforce 8600GR oder neuer",
    "Radeon 9000;Geforce5200 以上":"Geforce 8600GR oder neuer",
    "Core2 Duo Dual-core Processor 以上":"Core2 Duo Dual-Kern Prozessor oder neuer",
    "Pentium 1.4GHz 以上":"Pentium 1.4GHz oder besser",
    "Radeon 9000; Geforce5200 以上":"Radeon 9000;Geforce5200 oder neuer",
    "Windows 7/10 相容":"Windows 7/10 kompatibel",
    "註冊karos遊戲賬號":"Registrieren",
    "記憶卡":"Speicherkarte",
    "顯示卡":"Grafikkarte",
    "Windows 7/10相容":"Windows 7/10 kompatibel",
    "作業系統":"Betriebssystem",
    "請點擊上方按鈕下載遊戲主程式":"Klicken Sie auf die Schaltfläche oben, um den Spiel-Client herunterzuladen",
    "执行《Karos Online》系统需求":"Karos Online Minimum / empfohlene Spezifikationen Guide",
    "您的电脑可能需要达到以下配备":"Ihr Computer muss die folgenden Spezifikationen erfüllen",
    "windows遊戲主程式":"Windows Spiel Hauptprogramm",
    "安裝配備":"Installations-Spezifikation",
    "最低配备":"Mindestanforderung",
    "推荐配备":"empfohlene technische System ",
    "會員資料":"Meine Seite",
    "硬碟容量":"Festplattenkapazität",
    "會員賬號":"Mitgliedskonto",
    "查看更多":"Meine Seite",
    "more":"Mehr anzeigen",
    "回報記錄":"回報記錄",
    "查看详情":"Details abfragen",
    "官網首頁": "Hauptseite",
    "最新消息": "Aktuelle Nachrichten",
    "綜合": "Synthese",
    "公告": "Notice",
    "活動": "Aktivität",
    "更新": "Update",
    "职业定位":"Klasse",
    "职业":'Klasse',
    '初学者':"Neue ",
    "物品":"Gegenstände",
    "遊戲資訊": "Informationen zum Spiel",
    "遊戲地圖": "Spielkarte",
    "遊戲指南": "Leitfaden zum Spiel",
    "遊戲视频": "videos",
    "社群": "Community",
    "圖片分享區": "Bild Tafel",
    "攻略討論區": "Strategie Tafel",
    "玩家討論區": "Freies Brett",
    "客服中心": "Kundenservice",
    "1:1詢問": "1:1 Frage",
    "會員條款": "Nutzungshinweise",
    "下載專區": "Herunterladen",
    "游戲下載": "Spiel herunterladen",
    "商城": "Shop",
    "儲值點數": "Gespeicherte Wertpunkte",
    "購買元寶": "Geld kaufen",
    "購買記錄": "Kaufverlauf",
    "儲值記錄": "Aufladung Protokoll",
    "會員註冊": "Registrieren",
    "查詢帳號": "konto Abfrage",
    "查詢密碼": "Mein Passwort finden",
    "登入": "Einloggen",
    "登出": "Ausloggen",
    "我的資料": "Mein Profil",
    "密碼更改": "Passwort ändern",
    "我的點数：": "Mein Pang Gel:",
    "購買P-point後": "P-Punkt nach dem Kauf ",
    "Punkt": "點",
    "玩家必須先儲值點數，方可在 購買元寶 頁面購買karos的元寶": "Um den Geld online kaufen zu können, müssen Sie zunächst Ihr Pang Geld aufladen.",
    "上一頁": "Vorherige Seite",
    "下一頁": "Nächste Seite",
    "例行維護時間": "Regelmäßige Wartungszeit: ",
    "每週四": "Jeden Dienstag 10:00 - 12:00",
    "客服服務時間": "Öffnungszeiten des Kundenservice: ",
    "週一至週五": "Mo - Fr 10:00~ 12:30 / 13:30~ 18:30",
    "客服信箱": "Kundenservice E-Mail",
    "視頻": "Video",
    "原畫": "Originalmalerei",
    "發文": "Posten",
    "輸入關鍵字": "Schlüsselwörter eingeben",
    "搜索": "Suchen",
    "全文": "Volltext",
    "主題": "Titel",
    "會員帳號": "Mitgliedskonto",
    "安裝/執行": "Installieren / Ausführen",
    "儲值/購買": "Aufladen / Kaufen",
    "遊戲問題": "Problem mit dem Spiel",
    "消費記錄": "Verbrauchsprotokoll",
    "訂單編號": "Bestellnummer",
    "支付途徑":'Zahlungsweg',
    "交易號":'Transaktionsnummer',
    "狀態": "Status",
    "商品": "Ware",
    "價格": "Kaufpreis",
    "登錄日": "Login-Datum",
    "實名認證": "Bestätigt",
    "我的禮包": "Mein Spiel",
    "暱稱：": "Nickname :",
    "帳號：": "Konto : ",
    "密碼": "Passwort",
    "信箱：": "E-Mail :",
    "手機號碼：": "Handynummer :",
    "同意接受": "Einverstanden",
    "《會員服務條款》": "《Mitglieder-Servicebedingungen》",
    "《個人隱私條款》": "《Datenschutzrichtlinien》",
    "同意接受 Panggame 消息及廣告訊息": "Ich bin damit einverstanden, von Panggame Nachrichten und Werbebotschaften zu erhalten",
    "同意接受在panggame提供的活動抽獎 及遊戲服務同意通知相關sms訊息": "Einverständnis zum Erhalt von Event-Lotterie- und Spiel-Diensten, die von Panggame bereitgestellt werden und die Zustimmung zu entsprechenden SMS-Benachrichtigungen",
    "輸入新密碼": "Neues Passwort eingeben",
    "請確認密碼": "Bitte prüfen Sie Ihr Passwort.",
    "姓名": "Vollname",
    "請輸入身份證號": "Bitte Sozialversicherung eingeben",
    "取消": "Abbrechen",
    "確認": "Bestätigen",
    "記住登入資訊": "Anmeldeinformationen merken",
    "手機找回": "Mit dem Handy suchen",
    "信箱找回": "E-Mail Adresse finden",
    "手機": "Handy",
    "請輸入信箱": "Bitte E-Mail eingeben",
    "信箱格式有誤": "Falsches E-Mail-Format",
    "請輸入姓名": "Bitte Namen eingeben",
    "請輸入密碼": "Bitte Passwort eingeben",
    "請輸入手機號": "Bitte Handynummer eingeben",
    "手機號碼不正確，請重新輸入": "Die Nummer ist fehlerhaft. Bitte erneut versuchen.",
    "請輸入手機號碼": "Bitte Handynummer eingeben",
    "請輸入文章主題": "Bitte Posttitel eingeben",
    "請輸入新的信箱地址": "Bitte neue E-Mail Adresse eingeben",
    "請輸入正確帳號": "Bitte gültiges Konto eingeben",
    "請輸入自訂帳號": "Selbstdefinieren Bitte geben Sie Ihr Konto ein",
    "請輸入角色": "Bitte Charaktername eingeben",
    "請輸入帳號": "Bitte Konto eingeben",
    "請輸入郵箱": "Bitte E-Mail eingeben",
    "請輸入驗證碼": "Bitte Verfifizierungscode eingeben",
    "驗證碼為 6 位數字": "Der Authentifizierungscode ist 6-stellig.",
    "獲取驗證碼": "Verifizierungscode erhalten",
    "驗證碼": "Authentifizierungscode :",
    "修改": "Bearbeiten",
    "信箱註冊": "E-Mail-Mitgliedschaft Registrierung",
    "手機註冊": "Handy-Mitgliedschaft anmelden",
    "歡迎加入panggame!": "Willkommen bei Panggame!",
    "爲使用遊戲，請按照以下的格式進行註冊流程。": "Um das Spiel nutzen zu können, folgen Sie bitte dem Registrierungsverfahren für die Mitgliedschaft, um sich anzumelden.",
    "完成註冊，即刻獲得上市祝福禮包！": "Registrieren Sie sich und erhalten Sie sofort ein Open Celebration Package",
    "購買": "Kaufen",
    "點數是什麼？": "Was ist Pang Geld?",
    "點數購買": "punkt für Karos Online kaufen",
    "儲值點數時，請先確認金額後再購買": "Bitte überprüfen Sie zuerst den Kaufbetrag, wenn Sie die Punkte aufladen.",
    "購買成功": "Kauf erfolgreich",
    "點数不足": "Unzureichend Panggeld",
    "消耗點數：": "Geld verbrauch:",
    "當前點數：": "Jetzt Panggeld:",
    "購買價格：": "Kaufpreis:",
    "道具資訊：": "Informationen zum Objekt:",
    "持有點數：": "Mein Geld:",
    "游戏使用":"Verwendung vom Spiel",
    "儲值":"Aufladen",
    "運營":"Betrieb",
    "檢舉":"Melden",
    "全服通用":"Alle Server",
    "伺服器":"Server",
    "角色":"Charaktere",
    "扣除後點數：": "Geld nach Abzug :",
    "您正在購買元寶": "Ich kaufe den Geld",
    "取消購買": "Kauf abbrechen",
    "確認購買": "Kauf Bestätigung",
    "儲值點數：": "Gespeicherte Wertpunkte :",
    "儲值後點數：": "Punkte nach dem Aufladen :",
    "暱稱僅有一次修改機會": "Sie können Ihren Spitznamen nur einmal bearbeiten.",
    "輸入新暱稱": "Neuen Nickname eingeben",
    "舊信箱地址：": "Vorherige Mail-Adresse :",
    "新信箱地址：": "Neue E-Mail Adresse :",
    "舊手機號碼：": "Vorherige Handynummer :",
    "新手機號碼：": "Neue Handynummer :",
    "手機：": "Handynummer :",
    "已處理":"Bearbeitet",
    "待處理":"Ausstehend",
    "發送成功": "Erfolgreich versendet",
    "上載失敗": "Hochladen fehlgeschlagen",
    "兩次輸入的密碼並不相符，請重新輸入": "Die zweimal eingegebenen Passwörter stimmen nicht überein. Bitte erneut versuchen.",
    "請勾選同意接受條款": "Bitte auswählen, um den Bedingungen zuzustimmen",
    "註冊成功": "Erfolgreich",
    "分類": "Klassifizierung",
    "問題": "Problem",
    "聊天": "Chat",
    "建議": "Empfehlung",
    "刪除文章":"Artikel löschen",
    "留言": "Botschaft",
    "上留言": "Bitte eine Nachricht hinterlassen",
    "回復": "Kommentar",
    "请输入关键字": "Bitte geben Sie ein Schlüsselwort ein",
    "發佈辱罵,相同文章重覆發文,誹謗,謠言等違反營運政策的貼文時，可能會受到限制發文，若有違法情事發生，自行負擔法律相關責任. 最長100個字元": "Beiträge, die gegen die Betriebsrichtlinien verstoßen, wie z. B. Beleidigungen, wiederholtes Posten desselben Artikels, Rufmord, Gerüchte usw., können eingeschränkt werden und im Falle eines Verstoßes haften Sie für die rechtliche Verantwortung. {Länge} / max. 100 Zeichen",
    "使用點數": "Punkte benutzen",
    "當前點數": "Jetzt Panggeld ",
    "商品名": "Produktname",
    "確認密碼": "Passwort",
    "您的信箱地址": "Ihre E-Mail Adresse",
    "請輸入賬號": "Bitte Konto eingeben",
    "密碼長度最少為 8 字元": "Das Passwort muss mindestens 8 Zeichen oder mehr enthalten.",
    "密碼不能有特殊字元": "Passwörter dürfen keine Sonderzeichen enthalten.",
    "自訂賬號需為英文字母和數字的組合，且第一個字元必須為英文，英文及數字必須為半形": "Der Spitzname muss eine Kombination aus Buchstaben und Zahlen sein, der erste Buchstabe muss lateinisch sein und die Buchstaben und die Zahl müssen halb so breit sein.",
    "自訂賬號長度最多為 32 字元": "Nicknames können bis zu 32 Zeichen lang sein.",
    "修改成功": "Erfolgreich bearbeitet",
    "商城→購買元寶":"Einkaufscenter → Geld kaufen",
    "登出成功":"Ausloggen erfolgreich",
    "未查找到該賬號": "Konto nicht gefunden",
    "暫無數據": "Keine Daten",
    "賬號第一位必須為英文字母，最多 32 個字元": "Der erste Buchstabe des Kontos muss ein Buchstabe sein (bis zu 32 Zeichen)",
    "請輸入自訂賬號": "Bitte Nickname eingeben",
    "立即註冊": "Jetzt Registrieren",
    "極速下載": "Schnell Registrieren",
    "新手指南": "Anfängerführer",
    "裝備技能": "Ausrüstung/ Fähigkeit",
    "進階攻略": "Werbestrategie",
    "其他": "sonstige",
    "角色介绍": "Charaktere Einführung",
    "已删除": "Löschen abgeschlossen",
    "刪除": "Löschen",
    "刪除留言": "Kommentare löschen",
    "確定要刪除嗎？": "weiterhin löschen?",
    "OnGate 账号:": "OnGate 账号:",
    "二次登录密码:": "二次登录密码:",
    "真实姓名:": "Persönlicher Name:",
    "出生日期:": "Geburtsdatum:",
    "请输入OnGate 账号": "请输入OnGate 账号",
    "请输入游戏账号二次登录密码": "请输入游戏账号二次登录密码",
    "请输入真实姓名": "请输入真实姓名",
    "请输入出生日期": "请输入出生日期",
    "请输入密码": "Bitte Passwort eingeben",
    "請選擇分類": "請選擇分類",
    "請輸入": "Bitte eingeben",
    "請輸入主題": "請輸入主題",
    "请输入手机号码接收验证码信息": "请输入手机号码接收验证码信息",
    "请输入邮箱接收验证码信息": "请输入邮箱接收验证码信息",
    "实名认证信息不对": "tatsächlichen Namens Fehler bei der Eingabeinformationen",
    "確認新密碼不一致": "Passwort bestätigen",
    "點": "Punkt",
  }
  
  module.exports =  de
  